module.exports = __webpack_public_path__ + "static/media/6613153.9250d9fb.jpg";